// Built @Wed, 27 Dec 2023 03:56:16 GMT
import { typeof as _typeof } from "../_virtual/_rollupPluginBabelHelpers.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.constructor.js";
var DEBUG = typeof window !== "undefined" && window.location.href.indexOf("loggerdebug") > -1;
function computeWatchDur() {
  var played = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var watchDur = 0;
  for (var i = 0; i < played.length; i++) {
    var _end = played[i].end, _begin = played[i].begin;
    if (Number.isNaN(Number(_end)) || Number.isNaN(Number(_begin)) || _begin < 0 || _end < 0 || _end < _begin) {
      continue;
    }
    watchDur += played[i].end - played[i].begin;
  }
  watchDur = parseInt(watchDur * 1e3, 10);
  return watchDur;
}
function getHostFromUrl(url) {
  if (url === null || url === void 0 || url === "" || typeof url !== "string") {
    return "";
  }
  var results = url.split("/");
  var domain = "";
  if (results.length > 3 && results[2]) {
    domain = results[2];
  }
  return domain;
}
function generateSessionId(did) {
  var d = (/* @__PURE__ */ new Date()).getTime();
  try {
    did = parseInt(did);
  } catch (e) {
    did = 0;
  }
  d += did;
  if (window.performance && typeof window.performance.now === "function") {
    d += window.performance.now();
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
  return uuid;
}
function isType(type) {
  return function(value) {
    return Object.prototype.toString.call(value) === "[object ".concat(type, "]");
  };
}
function getResponseHeaders(xhr) {
  var headerMap = {};
  if (xhr instanceof window.XMLHttpRequest) {
    try {
      var headers = xhr.getAllResponseHeaders();
      var arr = headers.trim().split(/[\r\n]+/);
      arr.forEach(function(line) {
        var parts = line.split(": ");
        var header = parts.shift();
        var value = parts.join(": ");
        headerMap[header] = value;
      });
    } catch (error) {
      return headerMap;
    }
  }
  return headerMap;
}
function log(message) {
  var _console;
  for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    optionalParams[_key - 1] = arguments[_key];
  }
  DEBUG && (_console = console).log.apply(_console, ["[logger]", message].concat(optionalParams));
}
function nowTime() {
  try {
    return Math.round(window.performance.now());
  } catch (error) {
    return (/* @__PURE__ */ new Date()).getTime();
  }
}
function curTimestamp() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function formatData(data, model) {
  var ret = {
    ext: data.ext || {},
    data: {}
  };
  Object.keys(data).map(function(key) {
    if (model[key]) {
      ret.data[model[key]] = data[key];
    } else {
      key !== "ext" && (ret.ext[key] = data[key]);
    }
  });
  return ret;
}
function getXhr(url) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(resolve, reject) {
    try {
      if (!url) {
        reject(new Error("url is undefined"));
      }
      var dTime = nowTime();
      var tTime = dTime;
      var result = {};
      var xhr = new window.XMLHttpRequest();
      xhr.open("get", url);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 2) {
          result.headers = getResponseHeaders(xhr);
          result.connectTime = nowTime() - tTime;
          result.status = xhr.status;
          result.statusText = xhr.statusText;
          dTime = nowTime();
        }
      };
      xhr.onload = function() {
        resolve(result);
      };
      xhr.onprogress = function(data) {
        var costTime = nowTime() - dTime;
        var speed = 0;
        speed = parseInt(data.loaded / 1e3 / (costTime / 1e3), 10);
        result.speed = speed | 0;
        result.costTime = costTime;
      };
      xhr.onerror = function() {
        if (!result.status) {
          result.status = -1;
          result.costTime = nowTime() - dTime;
        }
        reject(result);
      };
      xhr.ontimeout = function() {
        if (!result.status) {
          result.status = -2;
          result.costTime = nowTime() - dTime;
        }
        resolve(result);
      };
      xhr.onabort = function() {
        resolve(result);
      };
      xhr.responseType = "arraybuffer";
      xhr.timeout = options.timeout || 1e4;
      xhr.setRequestHeader("Range", "bytes=".concat(options.range || "0-1048576"));
      xhr.send();
    } catch (e) {
      reject(e);
    }
  });
}
function checkVideoSrcIsEmpty(src) {
  if (!src || window.location.href.indexOf(src) > -1) {
    return true;
  }
  return false;
}
function checkIsBlob(url) {
  return url ? /^blob:/.test(url) : false;
}
var KEYMAP = {
  x_response_sinfo: "x-response-sinfo",
  x_response_cache: "x-response-cache",
  x_response_cinfo: "x-response-cinfo"
};
function transformHeader(headers) {
  if (!headers) {
    return {};
  }
  var newHeaders = {};
  Object.keys(KEYMAP).map(function(key) {
    if (!headers[key] && typeof KEYMAP[key] === "string") {
      newHeaders[key] = headers[KEYMAP[key]] || "";
    } else if (!headers[key] && KEYMAP[key] instanceof Array) {
      var finalKey = KEYMAP[key].filter(function(item) {
        return headers[item] !== void 0;
      });
      if (finalKey.length > 0) {
        newHeaders[key] = headers[finalKey[0]];
      } else {
        newHeaders[key] = "";
      }
    }
  });
  return newHeaders;
}
function appendData(org, src) {
  if (!org) {
    return src;
  } else if (typeof src === "string" || typeof src === "number") {
    return "".concat(org, " ").concat(src);
  } else {
    return src;
  }
}
function typeOf(obj) {
  return Object.prototype.toString.call(obj).match(/([^\s.*]+)(?=]$)/g)[0];
}
function parseTempData() {
  var curData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var action = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  Object.keys(data).map(function(key) {
    if (action === "append") {
      curData[key] = appendData(curData[key], data[key]);
    } else {
      curData[key] = data[key];
    }
  });
  return curData;
}
function hasClass(el, className) {
  if (!el || !className) {
    return false;
  }
  try {
    return Array.prototype.some.call(el.classList, function(item) {
      return item === className;
    });
  } catch (e) {
    var orgClassName = el.className && _typeof(el.className) === "object" ? el.getAttribute("class") : el.className;
    return orgClassName && !!orgClassName.match(new RegExp("(\\s|^)".concat(className, "(\\s|$)")));
  }
}
function formatDefinition(def) {
  if (typeOf(def) === "String") {
    return def.replace("P", "p");
  } else if (!def) {
    return "";
  } else if (typeOf(def) === "Number") {
    return "".concat(def);
  }
}
function toJsonString(str) {
  try {
    return JSON.stringify(str);
  } catch (e) {
    return "";
  }
}
var URL_EXPIRED_TYPES = {
  UN_KNOW: 0,
  EXPIRED: 1,
  NO_EXPIRED: 2
};
function checkUrlIsExpired(url) {
  if (!url || typeOf(url) !== "String") {
    return 0;
  }
  var _t = 0;
  try {
    var reg = new RegExp("(\\?|&)x-tos-expires=([^&]*)(&|$)");
    var r = url.match(reg);
    if (r !== null) {
      _t = parseInt(r[2], 10);
    } else {
      var ret = url.split("/");
      if (ret.length > 5 && ret[4].length === 8) {
        _t = parseInt(ret[4], 16);
      }
    }
    if (_t > 0) {
      var _n = parseInt((/* @__PURE__ */ new Date()).getTime() / 1e3, 10);
      return _t < _n ? URL_EXPIRED_TYPES.EXPIRED : URL_EXPIRED_TYPES.NO_EXPIRED;
    }
    return URL_EXPIRED_TYPES.UN_KNOW;
  } catch (e) {
    return URL_EXPIRED_TYPES.UN_KNOW;
  }
}
function getPageVisibility() {
  if (typeof document === "undefined") {
    return 0;
  }
  return document.visibilityState === "visible" ? 1 : 0;
}
export {
  appendData,
  checkIsBlob,
  checkUrlIsExpired,
  checkVideoSrcIsEmpty,
  computeWatchDur,
  curTimestamp,
  formatData,
  formatDefinition,
  generateSessionId,
  getHostFromUrl,
  getPageVisibility,
  getResponseHeaders,
  getXhr,
  hasClass,
  isType,
  log,
  nowTime,
  parseTempData,
  toJsonString,
  transformHeader,
  typeOf
};
